import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-alert",
  "use": "ico-alert-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ico-alert\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.99922 2C7.4919 2 6.98458 2.24077 6.69625 2.72231L1.20332 11.8971C0.619359 12.8675 1.36756 14.1333 2.50265 14.1333H13.4921C14.6309 14.1333 15.3791 12.8675 14.7988 11.8971L9.30219 2.72231C9.01386 2.24077 8.50654 2 7.99922 2ZM7.52512 5.72827V10.3977H8.45946V5.72827H7.52512ZM7.52512 11.3316V12.2655H8.45946V11.3316H7.52512Z\" fill=\"#FF404B\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol